import React, { useState } from "react";

import { DialogContentText, TextField } from "@mui/material";

import ConfirmDialog from "components/shared/confirm-dialog";

interface CreateTemplateInputDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (userId: string) => void;
  isLoading: boolean;
}

const CreateTemplateInputDialog: React.FC<CreateTemplateInputDialogProps> = ({
  open,
  onClose,
  onConfirm,
  isLoading,
}) => {
  const [userId, setUserId] = useState("");

  const handleConfirm = () => {
    if (userId.trim()) {
      onConfirm(userId.trim());
      setUserId(""); // Reset for next use
    }
  };

  const handleClose = () => {
    setUserId("");
    onClose();
  };

  return (
    <ConfirmDialog
      title="Create New Template From Revision"
      open={open}
      cancelBtnLabel="Cancel"
      confirmBtnLabel={isLoading ? "Creating..." : "Create Template"}
      setOpen={(isOpen) => !isOpen && handleClose()}
      onConfirm={handleConfirm}
      disabled={!userId.trim() || isLoading}
    >
      <DialogContentText>
        Enter the User ID who will own the new template created from this
        revision.
      </DialogContentText>
      <TextField
        autoFocus
        margin="dense"
        label="User ID"
        type="text"
        fullWidth
        variant="outlined"
        value={userId}
        onChange={(e) => setUserId(e.target.value)}
        disabled={isLoading}
        data-testid="user-id-input"
        placeholder="user_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
        onKeyPress={(e) => {
          if (e.key === "Enter" && userId.trim() && !isLoading) {
            handleConfirm();
          }
        }}
      />
    </ConfirmDialog>
  );
};

export default CreateTemplateInputDialog;
